export const SAVE_INTERNAL_BANNERS = 'SAVE_INTERNAL_BANNERS';
export type SAVE_INTERNAL_BANNERS = typeof SAVE_INTERNAL_BANNERS;

export interface SaveInternalBanners {
    type: SAVE_INTERNAL_BANNERS;
}

export function saveInternalBannersAction(): SaveInternalBanners {
    return {
        type: SAVE_INTERNAL_BANNERS
    };
}
